import React, { useMemo } from 'react';
import { UsersHolidayUsageViewWithDataProvider } from "./UsersHolidayUsageViewWithDataProvider";
import { BasicUserInfo } from '@shared/models/user.models';
import { useSelector } from "react-redux";
import { selectConfig } from '@shared/store/config.duck';
import { selectCurrentUser } from '@shared/store/auth.duck';
import { WithWeeksInCurrentCalendarMonth } from '@features/whereabouts/hooks/WithWeekInCurrentCalendarMonth';
import { WithCanUserViewHolidayInfoPopup } from "./WithCanUserViewHolidayInfoPopup";

export function HolidayUsagePopup(props: Props) {
  const {user} = props;
  const weeksInMonth = WithWeeksInCurrentCalendarMonth();
  const firstDay = weeksInMonth[0];
  const config = useSelector(selectConfig);
  const currentUser = useSelector(selectCurrentUser);
  const canUserViewPopup = WithCanUserViewHolidayInfoPopup(currentUser, user);

  const holidayYearStartDate = useMemo(() => config.getHolidayYearStartDate(firstDay), [config, firstDay]);

  if (!canUserViewPopup) {
    return null;
  }

  return (
    <>
      <UsersHolidayUsageViewWithDataProvider userId={user.userId} date={holidayYearStartDate} />
    </>
  )
}

interface Props {
  user: BasicUserInfo;
}
